<script>
import { Tabs, Tab, Field, Dialog, Icon } from 'vant'
import MatchNameInput from '@/components/org/MatchNameInput'
import ImageUploader from '@/components/org/ImageUploader'
import AreaSelector from '@/components/org/AreaSelector'
import PickerSelector from '@/components/org/PickerSelector'
import CalendarSelector from '@/components/org/CalendarSelector'
import MatchRule from '@/tbs/model/vo/MatchRule'
import { QNImageUtil } from '@/utils'
import { getPOI } from '@/libs/ds-bridge'

const matchRule = new MatchRule

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-info-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-field': Field,
        'van-icon': Icon,
        'match-name-input': MatchNameInput,
        'image-uploader': ImageUploader,
        'area-selector': AreaSelector,
        'picker-selector': PickerSelector,
        'calendar-selector': CalendarSelector,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                id: null,
                status: null,
                organizationId: null,
                brandId: null,
                brandName: null,
                brandLogoUrl: null,
                year: null,
                session: null,
                name: null,
                logoUrl: null,
                logo: null,
                posterUrl: null,
                poster: null,
                areaId: null,
                area: null,
                numSelection: null,
                type: null,
                startDate: null,
                endDate: null,
                fieldLocation: null,
                teamTotal: null,
                presenter: null,
                organizer: null,
                coorganizer: null,
                advisor: null,
                summary: null,
            },
            cityRegion: {
                areaList: null,
                areaIdList: null
            },
            active: 0,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        numSelectionIndex() {
            return matchRule.numSelectionIndex
        },
        numSelectionOptions() {
            return matchRule.numSelectionOptions
        },
        matchTypeOptions() {
            return matchRule.matchTypeOptions
        },
        readonly() {
            console.log('readonly', this.match.status)
            return !(this.match.status === '1')
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        match(value) {
            // console.log('@watch match', value)
            // save the initial team total as the first previous value
            this.prevTeamTotal = value.teamTotal
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        getPOI() {
            //这边先写死上海了
            getPOI({'cityId':'5643', 'cityName': '上海'});
        },
        onAreaSelectorDataChange(data) {
            console.log('onAreaSelectorDataChange', data)
            if (data.code == this.match.areaCode) {
                return
            }
            this.match.areaId = this.convertAreaCode2Id(data.code)
            this.match.area = data.label
            this.submitData()
        },
        onNumSelectionDataChange(data) {
            console.log('onNumSelectionDataChange', data)
            if (data.value == this.match.numSelection) {
                return
            }
            // confirm the change
            this.showConfirmDialog(this.locale['change-number-selection'], 'numSelection', data.value)
        },
        onTypeDataChange(data) {
            console.log('onTypeDataChange', data)
            if (data.value == this.match.type) {
                return
            }
            // confirm the change
            this.showConfirmDialog(this.locale['change-type'], 'type', data.value)
        },
        onStartDateDataChange(data) {
            console.log('onStartDateDataChange', data)
            if (data == this.match.startDate) {
                return
            }
            this.match.startDate = data
            this.submitData()
        },
        onEndDateDataChange(data) {
            console.log('onEndDateDataChange', data)
            if (data == this.match.endDate) {
                return
            }
            this.match.endDate = data
            this.submitData()
        },
        onMatchBrandClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchBrand',
                    query: {
                        from: 'OrgEditMatch',
                        matchId: this.match.id,
                        organizationId: this.match.organizationId,
                        matchBrandId: this.match.brandId
                    }
                }
            })
        },
        onMatchNameDataChange(value) {
            console.log('@onMatchNameDataChange', value)
            this.match.name = value.name
            this.match.year = value.year
            this.match.session = value.session
            this.submitData()
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', data)
            this.match.logo = data
            this.submitData()
        },
        onPosterUploaderDataChange(data) {
            console.log('onPosterUploaderDataChange', data)
            this.match.poster = data
            this.submitData()
        },
        onTeamTotalFieldInput(data) {
            console.log('onTeamTotalFieldInput', data)
            if (!data) {
                return
            }
            // confirm the change
            this.showConfirmDialog(this.locale['change-team-total'], 'teamTotal', this.prevTeamTotal, true)
            this.prevTeamTotal = data
        },
        onFieldInput(data) {
            // console.log('onFieldInput', data)
            if (data != null) {
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-match'],
                message: this.locale['delete-match-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onSaveBtnClick() {
            if (this.match.name) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.match,
                })
            } 
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        submitData() {
            console.log('submitData')
            if (this.match.name) {
                this.$emit('custom-event', {
                    type: 'submit',
                    data: this.match,
                })
            } 
        },
        showConfirmDialog(title, prop, value, reverse) {
            // confirm the change
            Dialog.confirm({
                title: title,
                message: this.locale['change-match-rule-confirm-message']
            }).then(() => {
                // on confirm
                if (!reverse) {
                    this.match[prop] = value
                }
                this.submitData()
            }).catch(() => {
                // on cancel
                if (!reverse) {
                    const self = this
                    const originValue = this.match[prop]
                    this.match[prop] = value
                    // delay to restore the value in the next tick
                    setTimeout(function() {
                        self.match[prop] = originValue
                    }, 100)
                }
                else {
                    this.match[prop] = value
                }
            })
        },
        convertAreaCode2Id(code) {
            console.log('convertAreaCode2Id', code)
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                if (areaIdList.province_list[code]) {
                    return areaIdList.province_list[code]
                }
                else if (areaIdList.city_list[code]) {
                    return areaIdList.city_list[code]
                }
                else if (areaIdList.county_list[code]) {
                    return areaIdList.county_list[code]
                }
            }
            return '1'
        },
        convertAreaId2Code(id) {
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                for (let p in areaIdList.province_list) {
                    if (areaIdList.province_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.city_list) {
                    if (areaIdList.city_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.county_list) {
                    if (areaIdList.county_list[p] == id) {
                        return p
                    }
                }
            }
        },
    },
}
</script>

<template>
    <div class="match-info-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <van-tabs
            v-model="active" 
            scrollspy sticky
            offset-top="43"
        >
            <van-tab :title="locale['base-info']">
                <match-name-input
                    class="b-outer-margin"
                    :matchBrandName="match.brandName"
                    :matchBrandLogoUrl="adjustImageSize(match.brandLogoUrl, 60, 60)"
                    :matchYear="match.year"
                    :matchSession="match.session"
                    :matchName="match.name"
                    @click-link="onMatchBrandClick"
                    @change-data="onMatchNameDataChange"
                />
                <image-uploader
                    :label="locale['match-logo-label']"
                    :description="locale['match-logo-placeholder']"
                    :oversizeMax="5000*1024"
                    :oversizeHint="locale['upload-image-oversize']"
                    :imageUrl="adjustImageSize(match.logoUrl, 400, 400)"
                    @change-data="onLogoUploaderDataChange"
                />
                <image-uploader
                    class="b-outer-margin"
                    :label="locale['match-poster-label']"
                    :description="locale['match-poster-placeholder']"
                    :oversizeMax="5000*1024"
                    :oversizeHint="locale['upload-image-oversize']"
                    :imageUrl="adjustImageSize(match.posterUrl, 600, 300)"
                    @change-data="onPosterUploaderDataChange"
                />
                <area-selector
                    :label="locale['city-region']"
                    :all="locale['all']"
                    :allArea="locale['whole-nation']"
                    :areaList="cityRegion.areaList"
                    :selectedAreaCode="convertAreaId2Code(match.areaId)"
                    :selectedAreaLabel="match.area"
                    @change-data="onAreaSelectorDataChange"
                />
                <picker-selector
                    :label="locale['match-num-selection-label']"
                    :options="numSelectionOptions"
                    :index="numSelectionIndex"
                    :value="match.numSelection"
                    :disabled="readonly"
                    @change-data="onNumSelectionDataChange"
                />
                <picker-selector
                    :label="locale['match-type-label']"
                    :options="matchTypeOptions"
                    :value="match.type"
                    :disabled="readonly"
                    @change-data="onTypeDataChange"
                />
                <calendar-selector
                    :label="locale['match-start-date-label']"
                    :dateFormat="locale['match-date-format']"
                    :value="match.startDate"
                    @change-data="onStartDateDataChange"
                />
                <calendar-selector
                    :label="locale['match-end-date-label']"
                    :dateFormat="locale['match-date-format']"
                    :value="match.endDate"
                    @change-data="onEndDateDataChange"
                />
                <van-field
                    v-model="match.teamTotal"
                    :label="locale['match-team-total-label']"
                    :disabled="readonly"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="3"
                    @input="onTeamTotalFieldInput"
                />
            </van-tab>
            <van-tab :title="locale['match-info']">
                <div class="u-outer-padding">
                    <span class="minor-text minor-color">{{ locale['match-info-title'] }}</span>
                </div>
                <van-field
                    name="match-presenter"
                    v-model="match.presenter" 
                    :label="locale['presenter-unit-label']" 
                    :placeholder="locale['presenter-unit-placeholder']"
                    clearable
                    input-align="right"
                    type="textarea"
                    rows="1"
                    autosize
                    maxlength="50" 
                    @input="onFieldInput"
                />
                <van-field
                    name="match-organizer"
                    v-model="match.organizer"
                    :label="locale['organizer-unit-label']"
                    :placeholder="locale['organizer-unit-placeholder']"
                    clearable
                    input-align="right"
                    type="textarea"
                    rows="1"
                    autosize
                    maxlength="50"
                    @input="onFieldInput"
                />
                <van-field
                    name="match-coorganizer"
                    v-model="match.coorganizer"
                    :label="locale['coorganizer-unit-label']"
                    :placeholder="locale['coorganizer-unit-placeholder']"
                    clearable
                    input-align="right"
                    type="textarea"
                    rows="1"
                    autosize
                    maxlength="150"
                    @input="onFieldInput"
                />
                <van-field
                    name="match-advisor"
                    v-model="match.advisor"
                    :label="locale['advisor-unit-label']"
                    :placeholder="locale['advisor-unit-placeholder']"
                    clearable
                    input-align="right"
                    type="textarea"
                    rows="1"
                    autosize
                    maxlength="250"
                    @input="onFieldInput"
                />
            </van-tab>
            <van-tab :title="locale['summary-info']">
                <div class="u-outer-padding">
                    <span class="minor-text minor-color">{{ locale['summary-info-title'] }}</span>
                </div>
                <van-field
                    v-model="match.summary"
                    :placeholder="locale['match-summary-placeholder']"
                    clearable
                    type="textarea"
                    rows="6"
                    autosize
                    maxlength="500" 
                    show-word-limit
                    @input="onFieldInput"
                />
            </van-tab>
        </van-tabs>
        <div class="delete-section t-outer-margin b-outer-margin">
            <div 
                class="cell-height vertical-center justify-center minor-color" 
                @click="onDeleteBtnClick">
                <van-icon name="delete-o" size="20"/>
                <span class="l-inner-margin minor-text">{{ locale['delete-match'] }}</span>
            </div>
        </div>
    </div>
</template>